<template>
    <div>
        <div class="row" v-if="additionalcfg">
            <div class="col col-12" style="padding-top:20px;padding-bottom:20px;">
                <label class="text-muted fs-6 fst-italic">
                    <i class="bi bi-exclamation-circle text-warning"></i> Some portions of this page block are not editable directly because what is displayed is derived from website settings you choose in the Admin Portal. 
                    This means that whenever you make changes in the Admin Portal, this page block will automatically update with the new data without any further intervention on your part (pricing or scheduling settings, for example).
                    You can make changes to these values by <a :href="additionalcfg" class="link">following this link</a>
                </label>
            </div>
            <hr style="margin-top: 10px; margin-bottom:5px;" />
        </div>
        <propertyfeaturetieeditor v-if="!hidefeaturetie" :propertyname="'FeatureTie'" :blockprops="BlockProps" :prompt="'Feature Tie'"></propertyfeaturetieeditor>
        <propertyrangeeditor min="1" max="200" step="1" propertyname="PaddingTop" :blockprops="BlockProps" prompt="Top Margin"></propertyrangeeditor>
        <propertyrangeeditor min="1" max="200" step="1" propertyname="PaddingBottom" :blockprops="BlockProps" prompt="Bottom Margin"></propertyrangeeditor>
        <propertytogglededitor propertyname="Shadow" :blockprops="BlockProps" prompt="Drop Shadow"></propertytogglededitor>
        <propertycoloreditor :propertyname="'BGColor'" :blockprops="BlockProps" :prompt="'Block Background Color'"></propertycoloreditor>

    </div>
</template>


<script>
    import propertycoloreditor from './propertycoloreditor.vue';
    import propertytogglededitor from './propertytogglededitor.vue';
    import propertyiconeditor from './propertyiconeditor.vue';
    import propertyrangeeditor from './propertyrangeeditor.vue';
    import propertyfeaturetieeditor from './propertyfeaturetieeditor.vue';
    
    export default {
        name: 'propertybaseeditors',
        emits: [],
        components: {
            'propertycoloreditor': propertycoloreditor,
            'propertytogglededitor': propertytogglededitor,
            'propertyiconeditor': propertyiconeditor,
            'propertyrangeeditor': propertyrangeeditor,
            'propertyfeaturetieeditor': propertyfeaturetieeditor
        },
        props: [
            "hidefeaturetie",
            "blockprops", 
            "additionalcfg"
        ],
        data() {
            return {    
            };
        },
        methods:
        {      
          
        },
        computed:
        {
            BlockProps: function(){
                return this.blockprops;
            }
        },
        beforeMount: function () {

        },
        mounted: function () {
        },
        beforeUnmount: function () {

        }
    }
</script>
